import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-273927d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex align-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/database.svg" }, null, -1))
const _hoisted_3 = { class: "flex col g0 align-start" }
const _hoisted_4 = { class: "f12 bold" }
const _hoisted_5 = { class: "f10 text-muted" }
const _hoisted_6 = {
  key: 1,
  class: "flex align-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/store.svg" }, null, -1))
const _hoisted_8 = { class: "flex col g0 align-start" }
const _hoisted_9 = { class: "f12 bold" }
const _hoisted_10 = { class: "f10 text-muted" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "flex col" }
const _hoisted_13 = { class: "flex justify-between align-center" }
const _hoisted_14 = {
  id: "container",
  class: "grid"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/store.svg" }, null, -1))
const _hoisted_17 = { class: "flex col g0 align-start" }
const _hoisted_18 = { class: "f12 bold" }
const _hoisted_19 = { class: "f10 text-muted" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/ico/database.svg" }, null, -1))
const _hoisted_22 = { class: "flex col g0 align-start" }
const _hoisted_23 = { class: "f12 bold" }
const _hoisted_24 = { class: "f10 text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, { ref: "popup" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_SearchBar, {
            targetGridId: "container",
            class: "grow"
          }),
          _withDirectives(_createVNode(_component_Tab, {
            onSwitch: _ctx.onTabChange,
            labels: ['Stores', 'Database']
          }, null, 8, ["onSwitch"]), [
            [_vShow, _ctx.role != _ctx.Role.Customer]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.tabIndex == 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.homeState.stores, (store) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: () => _ctx.onStoreClick(store),
                  class: "item"
                }, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(store.name), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(store.address), 1)
                  ])
                ], 8, _hoisted_15))
              }), 256))
            : _createCommentVNode("", true),
          (_ctx.tabIndex == 1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.homeState.databases, (database) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: () => _ctx.onDatabaseClick(database),
                  class: "item"
                }, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(database.name), 1),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(database.stores.length) + " stores.", 1)
                  ])
                ], 8, _hoisted_20))
              }), 256))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Button, null, {
        default: _withCtx(() => [
          (_ctx.selectedDatabase != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedDatabase.name), 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.selectedDatabase.stores.length) + " stores", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStore != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.selectedStore.name), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.selectedStore.address), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedStore == null && _ctx.selectedDatabase == null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Selectionner une valeur "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}